import React, { useEffect, useState } from 'react';
import { Accordion, AccordionSummary, Grid, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { searchStyles } from './styles';
import { StyledCheckbox } from '../../utils/functionsUtils';


const TableApproval = ({headers, data, setDataId, setOpen, dataId, clearForm, isModal}) => {
  const classes = searchStyles();
  const id = data.id;
  const [check, setCheck] = useState({});
  
  const getValueKey = (object, header) => {
      if (header.child === null) {
          if(header.field === 'fullName'){
            const name = `${data.firstName} ${data.secondName ?? ''} ${data.surname} ${data.secondSurname ?? ''}`;
            return name;
          }
          if(header.field === 'charge'){
            const charge = data?.charge?.denomination;
            return charge;
          }
          if (header.field) {
            let result = "";
            if (header.field.includes(",")) {
              header.field.split(/\s*,\s*/).forEach(function (myString) {
                result += object[myString] + " ";
              });
              return result;
            }
            return object[header.field];
          }
          return "";
      }
      if (isModal && header.title === 'Regional') {
        return object['regional'] && object['regional']['name'] ? object['regional']['name'] : "";
      }
      return object[header.field] && object[header.field][header.child] ? object[header.field][header.child] : "";
  };

  const FlippedOrderExpansionPanelSummary = withStyles({
    root: {
      flexDirection: "row-reverse",
    },
  })(AccordionSummary);
  FlippedOrderExpansionPanelSummary.defaultProps = {
    IconButtonProps: { edge: "start" },
  };

  const handleChangeChecked = (e) => {
    if(e.target.checked === true){
      setCheck(e.target.value);
      setDataId(e.target.value);
      setOpen(false)
      clearForm();
    }else{
      setCheck({});
      setDataId("");
    }
  }

  useEffect(() => {
    if(dataId){
      setCheck(dataId);
    }
  }, [dataId])
  
  return (
    <>
      <Grid container justifyContent='center' >
        <div className={classes.root}>
          <Accordion 
              style={{borderLeftStyle: "solid", borderLeftColor: '#F8DF13'}}
          >
              <FlippedOrderExpansionPanelSummary
                  aria-controls='panel1c-content'
                  id={id}
              >
                  <div>
                    <StyledCheckbox
                      color="success"
                      name="checkBox" 
                      value={data?.id}
                      defaultChecked={null}
                      checked={check === data?.id ? data?.id : false}
                      className={classes.checked}
                      onChange={(e) => handleChangeChecked(e)}
                      inputProps={{ 'aria-label': 'primary checkbox' }}
                      id={check}
                    />
                  </div>
                  {
                      headers.initialHeaders.map((header) => (
                          <div className={classes.column}>
                              <Typography className={classes.heading}>
                                  {header?.title}
                              </Typography>
                              <Typography className={classes.secondaryHeading}style={{flexBasis: 'auto', wordBreak: 'normal'}}>
                                {getValueKey(data, header)}
                              </Typography>
                          </div>
                      ))
                  }
              </FlippedOrderExpansionPanelSummary>
          </Accordion>
        </div>
      </Grid>
    </>
  )
}

export default TableApproval;